'use client';

import classnames from 'classnames';
import { forwardRef } from 'react';

import { useNotifications } from '@module/mdrt-org/shared/components/providers/notifications-context';
import { NotificationsBellIcon } from '@shared/ui-components/svgs';

import styles from './notifications-button.module.scss';

type NotificationsButtonProps = {
  onClick: () => void;
};

const PARENT_CLASSNAME = 'notifications-button';

export const NotificationsButton = forwardRef<HTMLButtonElement, NotificationsButtonProps>(
  ({ onClick }, ref) => {
    const { allNotificationsAreRead, cmsContent } = useNotifications();

    return (
      <button
        aria-label={cmsContent.notificationsDropdownTriggerLabel}
        className={classnames(styles[PARENT_CLASSNAME], {
          [styles[`${PARENT_CLASSNAME}--new`]]: !allNotificationsAreRead,
        })}
        data-ga-exclude-tracking
        onClick={onClick}
        ref={ref}
        type="button"
      >
        <div className={styles[`${PARENT_CLASSNAME}__icon-wrapper`]}>
          <NotificationsBellIcon />
        </div>
      </button>
    );
  }
);
